import { ContestWithId } from "../interfaces/IContests";
import { formatDateTime } from "../utils/dates";
import { useMemo } from "react";

export interface RegistrationStatus {
  isOpen: boolean;
  isCompleted: boolean;
  isStarted: boolean;
  canRegister: boolean;
  reason?: string;
}

export const useRegistrationValidation = (contest: ContestWithId): RegistrationStatus => {
  return useMemo(() => {
    const now = new Date();
    const registrationStart = new Date(contest.registrationStart);
    const registrationEnd = new Date(contest.registrationEnd);

    // Sprawdzenie czy rejestracja jest zakończona przez administratora
    if (contest.registrationCompleted) {
      return {
        isOpen: false,
        isCompleted: true,
        isStarted: true,
        canRegister: false,
        reason: "Rejestracja została zakończona przez administratora",
      };
    }

    // Sprawdzenie czy rejestracja jeszcze się nie rozpoczęła
    if (now < registrationStart) {
      return {
        isOpen: false,
        isCompleted: false,
        isStarted: false,
        canRegister: false,
        reason: `Rejestracja rozpocznie się ${formatDateTime(registrationStart)}`,
      };
    }

    // Sprawdzenie czy rejestracja się zakończyła (przekroczenie daty końcowej)
    if (now > registrationEnd) {
      return {
        isOpen: false,
        isCompleted: true,
        isStarted: true,
        canRegister: false,
        reason: `Termin rejestracji upłynął ${formatDateTime(registrationEnd)}`,
      };
    }

    // Rejestracja jest otwarta
    return {
      isOpen: true,
      isCompleted: false,
      isStarted: true,
      canRegister: true,
    };
  }, [contest.registrationStart, contest.registrationEnd, contest.registrationCompleted]);
};
